const updateIconRowScrollFade = (scrollEl) => {
  const row = scrollEl.closest(".split-header__icon-row");

  if (!row) {
    return;
  }

  const hasOverflow = scrollEl.scrollWidth > scrollEl.clientWidth + 1;
  const atEnd =
    scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 1;

  row.classList.toggle("is-overflowing", hasOverflow);
  row.classList.toggle("is-at-end", atEnd);
};

const initSplitHeaderIconRow = () => {
  document
    .querySelectorAll(".split-header__icon-row-scroll")
    .forEach((scrollEl) => {
      if (scrollEl.dataset.iconRowScrollInit) {
        return;
      }

      scrollEl.dataset.iconRowScrollInit = "true";

      const update = () => updateIconRowScrollFade(scrollEl);

      update();
      scrollEl.addEventListener("scroll", update, { passive: true });

      new ResizeObserver(update).observe(scrollEl);

      const list = scrollEl.querySelector(".icon-row");

      if (list) {
        new ResizeObserver(update).observe(list);
      }
    });
};

initSplitHeaderIconRow();
